import React from "react";
import { string, oneOf } from "prop-types";

import "./message-view.m.css";

const MessageView = ({ text, type }) => {
  if (!text) {
    return null;
  }

  return (
    <div styleName={type} className={`${type}-wrapper`}>
      {text}
    </div>
  );
};

MessageView.defaultProps = {
  type: "error",
};

MessageView.propTypes = {
  text: string,
  type: oneOf(["success", "error"]),
};

export default MessageView;
